// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1410bfd27b--wrapper--Pf0RA","wrapper--gap":"_1410bfd27b--wrapper--gap--qvHpE","phone":"_1410bfd27b--phone--kyExu"};